import config from "../../../constants/config.js";
import { meetingSocketFactory } from "../../../utils/socketFactory.js";
import { CONFERENCE_START, CONFERENCE_UPDATED, resetState, setState, startMeetingsSync } from "./ActiveConferenceSlice.js";
import { listenerMiddleware } from "../../../store/middleware.js";
import { getRoomConfig } from "../../MediaPlayback/store/livekitSlice/livekitThunks.js";
import formatMeetingData from "../utils/formatJsonPatchData.js";


listenerMiddleware.startListening({
    actionCreator: CONFERENCE_START,
    effect: async (action, listenerApi) => {
        const conferenceRoomId = action?.payload?.data?.roomTenantId
        if (!conferenceRoomId) return;
        const state = listenerApi.getState();
        if (state.MapDisplay.currentRoom.room_id !== conferenceRoomId) return;
        meetingSocketFactory.initializeSocket({
            url: config.SERVER_URL + '/meeting/' + action.payload.data.meetingId,
            options: {
                withCredentials: true,
                query: {
                    email: listenerApi.getState().auth.localAvatar.email,
                    id: listenerApi.getState().auth.localAvatar.id,
                    tenantId: listenerApi.getState().auth.tenant.id,
                    mapId: action.payload.id
                },
                auth: {
                    token: listenerApi.getState().auth.token
                }
            }
        });
        listenerApi.dispatch(startMeetingsSync())
    }
})


listenerMiddleware.startListening({
    actionCreator: getRoomConfig.fulfilled,
    effect: async (action, listenerApi) => {
        if (meetingSocketFactory.connected) {
            meetingSocketFactory.socket.disconnect();
        }
        const conferenceId = action.payload?.conferenceData?.conferenceId;
        if (conferenceId){
            meetingSocketFactory.initializeSocket({
            url: config.SERVER_URL + '/meeting/' + conferenceId,
            options: {
                withCredentials: true,
                query: {
                    email: listenerApi.getState().auth.localAvatar.email,
                    id: listenerApi.getState().auth.localAvatar.id,
                    tenantId: listenerApi.getState().auth.tenant.id,
                    mapId: action.payload.id
                },
                auth: {
                    token: listenerApi.getState().auth.token
                }
            }
        });
        listenerApi.dispatch(startMeetingsSync())
        } else {
            listenerApi.dispatch(resetState());
        }
    }
})


listenerMiddleware.startListening({
    actionCreator: CONFERENCE_UPDATED,
    effect: async (action, listenerApi) => {
        const formattedMeetingData = formatMeetingData(action.payload, listenerApi.getState().auth.localAvatar.id);

        
        listenerApi.dispatch(setState(formattedMeetingData))
    }
})
